
export class INdcLabeler {
 companyRevisionLabelerCode_ID: string;
 ndcLabelerCode: string;
}
